import "./Footer.css";

export const Footer = () => {
  return (
    <footer>
      <div className="footer">
        <h2>Made by Dhruv Samant</h2>
        <div className="footer-icon-container">
          <a target="_blank" href="https://github.com/B0llu">
            <i className="fab fa-github"></i>
          </a>
          <a target="_blank" href="https://twitter.com/TheBestDhruv">
            <i className="fab fa-twitter"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};
